<template>
    <div class="container">
      <div class="header">
        <img src="../../assets/imgs/pass.png" v-if="show">
        <img src="../../assets/imgs/fail.png" v-else>
      </div>
      <div class="content" v-if="show">恭喜通过</div>
      <div class="content" v-else>很遗憾未通过</div>
      <div class="fraction" v-if="show">
        <div v-cloak v-show="levelexams">
          <div class="item_left">{{fraction}}分</div>
          <div class="item_right">总分：100分</div>
        </div>
        <div v-cloak v-show="levelexamShow">
          <div class="item_left">答对{{fractions}}题</div>
          <div class="item_right">总题：{{quesum}}</div>
        </div> 
      </div>
      <div class="fraction" v-else>
        <div v-cloak v-show="levelexamShow">
          <div class="item_left">答对{{fractions}}题</div>
          <div class="item_right">总题：{{quesum}}</div>
        </div>
        <div v-cloak v-show="levelexams">
          <div class="item_left">{{fraction}}分</div>
          <div class="item_right">总分：100分</div>
        </div>
        <!-- <div class="info">{{countDownSecond}}秒后将返回首页</div> -->
      </div>
      <div class="adress" v-if="show">
        <div class="title">证书邮寄地址</div>
        <input class="input" v-model="name" placeholder="收货人"/>
        <input class="input" v-model="tel" placeholder="手机号" @blur="checkphone()"/>
        <v-distpicker @selected="onSelected" class="distpicker"></v-distpicker>
        <input class="input" v-model="deladress" placeholder="详细地址：如道路，门牌号，小区，楼栋号，单元室等"/>
      </div>
      <!--      <div class="photo" v-if="show">-->
      <!--          <el-upload-->
      <!--            class="avatar-uploader"-->
      <!--            :action="' '"-->
      <!--            accept=".png"-->
      <!--            :auto-upload="false"-->
      <!--            :file-list="HFfileList"-->
      <!--            :on-remove="HFhandleRemove"-->
      <!--            :on-change="HFhandleChangeImg"-->
      <!--          >-->
      <!--            <img v-if="hfpng" :src="hfpng" class="avatar">-->
      <!--            <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
      <!--          </el-upload>-->
      <!--          <div class="pho_info">-->
      <!--            <div>备注：</div>-->
      <!--            <div>1，支持的文件格式是jpg/png/jpeg </div>-->
      <!--            <div>2 ，一寸蓝底照片</div>-->
      <!--          </div>-->
      <!--      </div>-->
     <div class="footer" v-if="show">
       <el-button @click="submitAdress()">确认</el-button>
     </div>
      <el-dialog
        title=""
        :visible.sync="dialogVisible"
        width="30%">
        <span style="display: inline-block;
          width: 100%;
          font-size: 16px;
          text-align: center;
          color: rgb(153,151,151);height: 100px;
          line-height: 80px;">{{message}},{{countDownSeconds}}秒返回首页</span>
      </el-dialog>
    </div>
</template>

<script>
import {updateEnrollAddressById} from '../../api/index'
import VDistpicker from 'v-distpicker'
export default {
  name: 'testResults',
  components: { VDistpicker },
  data () {
    return {
      graId: '',
      fraction: 0,
      name: '',
      tel: '',
      province: '',
      city: '',
      area: '',
      show: true,
      deladress: '',
      adress: '',
      countDownSecond: '05',
      message: '',
      countDownSeconds: '05',
      dialogVisible: false,
      levelexam: '',
      levelexams: '',
      fractions: 0,
      levelexamShow: false,
      quesum: 0
      // levelexam13: false,
      // levelexam12: false,
      // levelexams: false
      // HFfileList: [],
      // hfpng: ''
    }
  },
  mounted () {
    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL)
    })
  },
  created () {
    
    this.gradId = this.$route.query.id
    this.fraction = this.$route.query.fraction
    this.fractions = this.$route.query.fractions
    this.levelexam = this.$route.query.levelexam
    // let num = Number(this.fraction)
    // if (num < 60 || this.fraction14 < 10 || this.fraction13 < 15) {
    //   this.show = false
    // }
    if (this.levelexam === '十六级' || this.levelexam === '十五级') {
      this.levelexams = true
      if (Number(this.fraction) < 60) {
        this.show = false
      }
    } else {
      this.levelexamShow = true
      if (this.levelexam === '十四级') {
        this.quesum = 15
        if (this.fractions < 9) {
          this.show = false
        }
      }else{
        this.quesum = 20
        if (this.fractions < 12) {
          this.show = false
        }
      }
      // if (this.levelexam === '十三级' || this.levelexam === '十二级') {
       
      // }
      // if (this.levelexam === '十一级') {
      //   this.quesum = 20
      //   if (this.fractions < 12) {
      //     this.show = false
      //   }
      // }
    }
    // if (this.levelexam === '十四级') {
    //   this.levelexam14 = true
    // }
    // if (this.levelexam === '十三级') {
    //   this.levelexam13 = true
    // }
    // if (this.levelexam === '十二级') {
    //   this.levelexam12 = true
    // }
    // if (this.levelexam !== '十三级' && this.levelexam !== '十四级') {
    //   this.levelexams = true
    // }
    // if (this.show === false) {
    //   var totalSecond = 4
    //   var interval = setInterval(function () {
    //     // 秒数
    //     var second = totalSecond
    //     // 天数位
    //     var day = Math.floor(second / 3600 / 24)
    //     var dayStr = day.toString()
    //     if (dayStr.length === 1) dayStr = '0' + dayStr
    //     // 小时位
    //     var hr = Math.floor((second - day * 3600 * 24) / 3600)
    //     var hrStr = hr.toString()
    //     if (hrStr.length === 1) hrStr = '0' + hrStr
    //     // 分钟位
    //     var min = Math.floor((second - day * 3600 * 24 - hr * 3600) / 60)
    //     var minStr = min.toString()
    //     if (minStr.length === 1) minStr = '0' + minStr
    //     // 秒位
    //     var sec = second - day * 3600 * 24 - hr * 3600 - min * 60
    //     var secStr = sec.toString()
    //     if (secStr.length === 1) secStr = '0' + secStr
    //     // this.countDownDay = dayStr
    //     // this.countDownHour = hrStr
    //     // this.countDownMinute = minStr
    //     this.countDownSecond = secStr
    //     totalSecond--
    //     console.log(totalSecond)
    //     if (totalSecond < 0) {
    //       clearInterval(interval)
    //       // 提交答案
    //       this.$router.push('/gradingTest')
    //     }
    //   }.bind(this), 1000)
    // }
  },
  methods: {
    onSelected (data) {
      console.log(data)
      this.adress = data.province.value + data.city.value + data.area.value
      console.log(this.adress)
    },
    checkphone () {
      let myreg = /^1[345789]\d{9}$/
      let str = this.tel
      if (myreg.test(str)) {
        this.$message.success('成功')
      } else {
        this.$message.error('抱歉手机号不合法,请检查之后再输入')
      }
    },
    submitAdress () {
      localStorage.removeItem('studentInfo')
      console.log(this.name, this.tel, this.deladress, this.graId)
      updateEnrollAddressById({
        parentName: this.name,
        phone: this.tel,
        address: this.adress + this.deladress,
        id: this.gradId
      }).then(res => {
        // success
        console.log(res)
        if (res.success === '1001') {
          this.dialogVisible = true
          this.message = '地址填写成功'
          var totalSecond = 4
          var interval = setInterval(function () {
            // 秒数
            var second = totalSecond
            // 天数位
            var day = Math.floor(second / 3600 / 24)
            var dayStr = day.toString()
            if (dayStr.length === 1) dayStr = '0' + dayStr
            // 小时位
            var hr = Math.floor((second - day * 3600 * 24) / 3600)
            var hrStr = hr.toString()
            if (hrStr.length === 1) hrStr = '0' + hrStr
            // 分钟位
            var min = Math.floor((second - day * 3600 * 24 - hr * 3600) / 60)
            var minStr = min.toString()
            if (minStr.length === 1) minStr = '0' + minStr
            // 秒位
            var sec = second - day * 3600 * 24 - hr * 3600 - min * 60
            var secStr = sec.toString()
            if (secStr.length === 1) secStr = '0' + secStr
            // this.countDownDay = dayStr
            // this.countDownHour = hrStr
            // this.countDownMinute = minStr
            this.countDownSeconds = secStr
            totalSecond--
            console.log(totalSecond)
            if (totalSecond < 0) {
              clearInterval(interval)
              // 提交答案
              this.$router.push('/gradingTest')
            }
          }.bind(this), 1000)
          // this.$message.success('地址填写成功，5秒将返回首页面')
          // setTimeout(() => {
          //   this.$router.push('/gradingTest')
          // }, 5000)
        } else {
          this.$message.error(res.error)
        }
      }).catch((error) => {
        // error
        console.log(error)
      })
    }
    // HFhandleChangeImg (file, fileList) {
    //   console.log(file, fileList)
    //   const isPNG = file.raw.type === 'image/png'
    //   const isLt2M = file.raw.size / 1024 / 1024 < 0.5
    //   if (fileList.length > 0) {
    //     // 单个覆盖上传
    //     this.HFfileList = [fileList[fileList.length - 1]] // 这一步，是 展示最后一次选择的csv文件
    //     if (!isPNG) {
    //       this.$message.error('上传图片只能是 PNG 格式!')
    //       return false
    //     } else if (!isLt2M) {
    //       this.$message.error('上传图片大小不能超过 200kb!')
    //       this.HFfileList = []
    //       return false
    //     } else if (isLt2M && isPNG) {
    //       // this.HFformData.file = file.raw // 待上传图片的url
    //       // this.dredgeServe.HFname = file.name
    //     }
    //   }
    //   // 预览
    //   // eslint-disable-next-line no-redeclare
    //   let files = file.raw
    //   let reader = new FileReader()
    //   let that = this
    //   reader.readAsDataURL(files)
    //   reader.onload = function (e) {
    //     that.hfpng = this.result // 上传前可预览图片路径
    //   }
    // },
    // HFhandleRemove (file, fileList) {}
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/base.scss";
  @import "../../assets/scss/mixin.scss";
  @import "../../assets/scss/config.scss";
  .container{
    .header{
      width: 211px;
      height: 211px;
      margin: auto;
      margin-top: 40px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .content{
      font-size: 40px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      text-align: center;
      letter-spacing: 3px;
      margin-top: 15px;
    }
    .fraction{
      width: 100%;
      text-align: center;
      margin-top: 15px;
      .item_left{
        display: inline-block;
        width: 190px;
        height: 80px;
        border: 2px solid #008DE9;
        border-radius: 37px;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #008EEA;
        text-align: center;
        line-height: 73px;
      }
      .item_lefts{
        display: inline-block;
        width: 140px;
        height: 73px;
        border: 2px solid #9A9A9A;
        border-radius: 37px;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9A9A9A;
        text-align: center;
        line-height: 73px;
      }
      .item_right{
        display: inline-block;
        width: 186px;
        height: 73px;
        border: 2px solid #9A9A9A;
        border-radius: 37px;
        margin-left: 72px;
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9A9A9A;
        text-align: center;
        line-height: 73px;
      }
      .info{
        font-size: 12px;
        text-align: center;
        color: #cecece;
        margin: 50px 0;
      }
    }
    .adress{
      width: 692px;
      border: 1px solid #008DE9;
      margin: auto;
      margin-top: 25px;
      padding: 25px;
      box-sizing: border-box;
      .title{
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #000000;
      }
      .input{
        width: 100%;
        height: 40px;
        border: 0;
        border-bottom: 1px solid #cecece;
        padding-left: 5px;
        margin-top: 20px;
      }
      .distpicker{
        margin-top: 20px;
      }
    }
    .photo{
      width: 692px;
      border: 1px solid #008DE9;
      margin: auto;
      margin-top: 25px;
      padding: 25px;
      box-sizing: border-box;
      @include alignflexed();
      .avatar-uploader{
        width: 178px;
        height: 178px;
        border: 1px dashed #d9d9d9!important;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        .el-upload--text{
          border: 1px dashed #d9d9d9!important;
        }
      }
      .pho_info{
        margin-left: 30px;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #DA0606;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
      }
      .avatar {
        width: 178px;
        height: 178px;
        display: block;
      }
    }
    .footer{
      width: 100%;
      margin: auto;
      text-align: center;
      .el-button{
        width: 127px;
        height: 52px;
        background: #008EE9;
        margin: 0;
        padding: 0;
        margin: auto;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        line-height: 52px;
        margin: 50px 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/grading_test/testResults.vue